var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SellHeader',{attrs:{"img_header":_vm.header_image,"header":"แก้ไขคำสั่งซื้อ","link_back":"sell/ordercustomermain"}}),_c('Order_customer_edit')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }